import type { ComponentProps, ReactNode } from "react";
import { cn } from "@/lib/utils";

interface HomepageSectionHeaderProps extends Omit<
  ComponentProps<"div">,
  "title"
> {
  description: ReactNode;
  descriptionClassName?: string;
  label?: ReactNode;
  title: ReactNode;
}

export function HomepageSectionHeader({
  children,
  className,
  description,
  descriptionClassName,
  label,
  title,
  ...props
}: HomepageSectionHeaderProps) {
  return (
    <div className={cn("max-w-xl", className)} {...props}>
      {label ? (
        <p className="text-primary text-sm font-semibold tracking-[0.16em]">
          {label}
        </p>
      ) : null}
      <h2 className="mt-3 text-3xl font-bold tracking-tight text-balance sm:text-4xl md:text-5xl">
        {title}
      </h2>
      <p
        className={cn(
          "text-muted-foreground mt-4 text-base leading-relaxed text-pretty md:text-lg",
          descriptionClassName,
        )}
      >
        {description}
      </p>
      {children}
    </div>
  );
}
